import { defineStore } from 'pinia';
import { IFooterMiniBanner } from '@/storePinia/stores/footerMiniBanner/interfaces/IFooterMiniBanner';
import { useResultsStore } from '@/storePinia/stores/results';
import { getExistingPiniaStore } from '@/storePinia';
import { ICatalog } from '@/storePinia/stores/catalog/interfaces/ICatalog';

type IFooterMiniBannerGetters = {
  getItem(state: IFooterMiniBanner): IFooterMiniBanner['items'][0] | undefined;
};

type IFooterMiniBannerActions = {
  refreshMiniBanner(payload: string): Promise<void>;
  handlerRemove(): Promise<void>;
};

export const useFooterMiniBannerStore = defineStore<
  'footerMiniBanner',
  IFooterMiniBanner,
  IFooterMiniBannerGetters,
  IFooterMiniBannerActions
>('footerMiniBanner', {
  state: (): IFooterMiniBanner => ({
    doShowMiniBanner: false,
    isShow: true,
    showNextItemTimeOut: 0,
    items: [],
    showItems: [],
  }),
  getters: {
    getItem: (state) => {
      try {
        return state?.showItems?.filter((el) => {
          const isShowByInterval = window.sessionStorage.getItem(
            `footerMiniBanner${el?.id}ShowAfter`
          );
          // if (!isShowByInterval) return undefined;
          if (!isShowByInterval) {
            return !window.sessionStorage.getItem(`isFooterMiniBanner${el?.id}WasShown`);
          }

          return (
            !window.sessionStorage.getItem(`isFooterMiniBanner${el?.id}WasShown`) &&
            new Date(isShowByInterval) <= new Date()
          );
        })[0];
      } catch (err) {
        console.log(err);
        return undefined;
      }
    },
  },
  actions: {
    async refreshMiniBanner(payload) {
      try {
        // якщо каталог стора створена взяти інстанс з каталог стори. Для оптимізації щоб не тянути стору каталогу по всіх сторінках сайту.
        const catalogStore = getExistingPiniaStore<ICatalog>('catalog');

        const catalogSectionId = catalogStore?.catalogSectionList?.section?.id;
        const collectionId = catalogStore?.collection?.id;

        const resultsStore = useResultsStore();

        const blogElementId = resultsStore.blogElement?.id;
        const actionId = resultsStore.action?.id;
        const newsElementId = resultsStore.newsElement?.id;
        const lang = resultsStore.getCurrentLang;

        const cabinetPagesItems = this.items?.filter((el) => {
          if (!el?.cabinetPages) return false; // додано захист

          const showInCabinetItems = el?.cabinetPages?.filter((cabinetPage) => {
            const cabinetPageByLocale = lang?.default
              ? cabinetPage
              : `/${lang?.code}${cabinetPage}`;
            return payload === cabinetPageByLocale;
          });
          return showInCabinetItems.length > 0;
        });
        const cabinetPagesItemsIDs = cabinetPagesItems?.map((el) => el?.id);

        // if (collectionId !== undefined) {
        const items = this.items?.filter(
          (el) =>
            el?.catalogIDs?.includes(`${catalogSectionId}`) ||
            el?.collectionsIDs?.includes(String(collectionId)) ||
            el?.blogIDs?.includes(`${blogElementId}`) ||
            el?.actionsIDs?.includes(`${actionId}`) ||
            el?.newsIDs?.includes(`${newsElementId}`) ||
            el?.isShowInService ||
            cabinetPagesItemsIDs?.includes(el?.id)
        ); // el?.isShowInCabinet || - commented because it break ajax cabinet loading

        this.$patch({
          showItems: items,
          doShowMiniBanner: items?.length > 0,
        });
        // }
      } catch (err) {
        console.error(err);
      }
    },
    async handlerRemove() {
      try {
        const id = this.getItem?.id;
        if (id) {
          /**
           * could be done by storage in array of banner ids, but it is what it is. Dimon, Borshaga, im really sorry...
           */
          window.sessionStorage.setItem(`isFooterMiniBanner${id}WasShown`, 'true');
          const nextBanner = this.showItems?.filter(
            (el) =>
              el?.id !== id && !window.sessionStorage.getItem(`isFooterMiniBanner${el?.id}WasShown`)
          )[0];

          this.$patch({
            isShow: false,
          });

          if (nextBanner && nextBanner?.id > 0) {
            const showAfter = new Date();
            showAfter.setSeconds(showAfter.getSeconds() + this.showNextItemTimeOut);
            window.sessionStorage.setItem(
              `footerMiniBanner${nextBanner?.id}ShowAfter`,
              showAfter.toString()
            );
          }
          await this.refreshMiniBanner(window.location.pathname);
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
});
